export default class TruncateFilter {
    public static transform(text: string | number, length: number, clamp?: string): string {
        text = String(text || '');
        const truncatedText = TruncateFilter.truncatedText(text, length);
        clamp = TruncateFilter.clamp(text, truncatedText, clamp);
        return truncatedText + clamp;
    }

    private static truncatedText(text: string, length: number): string {
        return text.slice(0, TruncateFilter.truncateLength(text, length));
    }

    private static clamp(originalText: string, truncatedText: string, clamp?: string): string {
        clamp = clamp ? clamp : '...';
        return truncatedText.length < originalText.length ? clamp : '';
    }

    private static truncateLength(text: string, length: number): number {
        if (length < text.length) {
            for (let i = length; i > 0; i--) {
                length = i;
                if (text[i] === ' ') {
                    break;
                }
            }
            if (text.length - length <= 3) {
                length = text.length;
            }
        }
        return length;
    }
}
